// lib/leasing/brandDisplay.ts
// Pure presentation helpers shared by the Brand renderers (BrandRenderer row/card).
// No React, no DOM. Note: normalizeIsoAlpha2CountryCode is NOT the same contract as the
// normalizeCountryCode exported by lib/leasing/country-continent.ts, which returns '' and maps
// full country names; this one returns null for anything that is not an ISO alpha-2 code.

export const formatSentenceCase = (value?: string | null): string => {
  if (!value) return '-';
  const normalized = value.replace(/_/g, ' ').trim().toLowerCase();
  if (!normalized) return '-';
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const toCountryFlag = (rawCountryCode: string | null | undefined): string => {
  const countryCode = (rawCountryCode ?? '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(countryCode)) return '';
  const offset = 127397;
  return Array.from(countryCode)
    .map((char) => String.fromCodePoint(char.charCodeAt(0) + offset))
    .join('');
};

export const normalizeIsoAlpha2CountryCode = (rawCountryCode: unknown): string | null => {
  if (typeof rawCountryCode !== 'string') return null;
  const countryCode = rawCountryCode.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(countryCode)) return null;
  return countryCode;
};

const BRAND_MARKET_POSITIONING_VALUES = new Set(['DISCOUNT', 'MASS_MARKET', 'PREMIUM', 'LUXURY'] as const);

export const normalizeBrandMarketPositioning = (value: unknown): 'DISCOUNT' | 'MASS_MARKET' | 'PREMIUM' | 'LUXURY' | null => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toUpperCase();
  if (!BRAND_MARKET_POSITIONING_VALUES.has(normalized as 'DISCOUNT' | 'MASS_MARKET' | 'PREMIUM' | 'LUXURY')) return null;
  return normalized as 'DISCOUNT' | 'MASS_MARKET' | 'PREMIUM' | 'LUXURY';
};

export const formatBrandMarketPositioningLabel = (value: 'DISCOUNT' | 'MASS_MARKET' | 'PREMIUM' | 'LUXURY' | null): string => {
  if (!value) return '?';
  if (value === 'MASS_MARKET') return 'Mass Market';
  return formatSentenceCase(value);
};
